<div [id]="chartId" class="chart">
</div>
